<template>
  <b-modal
    id="modal-create-company-wfh-day"
    ref="modal-create-company-wfh-day"
    title="Declare Company-Wide WFH Day"
    ok-title="Announce"
    cancel-title="Cancel"
    @ok="$emit('ok')"
    @hidden="$emit('hidden')"
    size="md"
    :ok-disabled="creatingCompanyWfhDay || !companyWfhDayForm.title.trim() || !companyWfhDayForm.date || !companyWfhDayForm.location"
  >
    <b-alert variant="info" show class="mb-3">
      <feather-icon icon="InfoIcon" size="14" class="mr-1" />
      On this date, punch-in/punch-out is still required for everyone covered.
      Nobody's personal WFH balance is deducted — this applies automatically
      to everyone, with no individual application needed.
    </b-alert>
    <b-form @submit.prevent="$emit('ok')">
      <b-form-group label="Reason / Title" label-for="company-wfh-day-title">
        <b-form-input
          id="company-wfh-day-title"
          v-model="companyWfhDayForm.title"
          placeholder="e.g. Company-wide WFH — Diwali travel advisory"
          required
          :disabled="creatingCompanyWfhDay"
        />
      </b-form-group>
      <b-form-group label="Date" label-for="company-wfh-day-date">
        <b-form-input
          id="company-wfh-day-date"
          v-model="companyWfhDayForm.date"
          type="date"
          required
          :disabled="creatingCompanyWfhDay"
        />
      </b-form-group>
      <b-form-group label="Applies To" label-for="company-wfh-day-location">
        <b-form-select
          id="company-wfh-day-location"
          v-model="companyWfhDayForm.location"
          :options="locationOptions"
          required
          :disabled="creatingCompanyWfhDay"
        >
          <template #first>
            <option :value="null">Select Location</option>
          </template>
        </b-form-select>
      </b-form-group>
      <div v-if="creatingCompanyWfhDay" class="text-center">
        <b-spinner variant="primary" size="sm" class="mr-2" />
        <span class="text-muted">Announcing company-wide WFH day...</span>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import {
  BModal, BForm, BFormGroup, BFormInput, BFormSelect, BSpinner, BAlert,
} from 'bootstrap-vue'

export default {
  name: 'CreateCompanyWfhDayModal',
  components: {
    BModal, BForm, BFormGroup, BFormInput, BFormSelect, BSpinner, BAlert,
  },
  props: {
    companyWfhDayForm: { type: Object, required: true },
    creatingCompanyWfhDay: { type: Boolean, default: false },
    locationOptions: { type: Array, default: () => [] },
  },
}
</script>
